// Catalogue taxonomy, ordered the way a buyer shops: compute first, then the
// things that connect and protect it, then the datacenter fabric it lives in.
// Each category owns one file under ./categories/.
import { server } from "./categories/server.js";
import { storage } from "./categories/storage.js";
import { network } from "./categories/network.js";
import { securityAppliances } from "./categories/securityAppliances.js";
import { componentsSpares } from "./categories/componentsSpares.js";
import { endUserComputing } from "./categories/endUserComputing.js";
import { softwareLicenses } from "./categories/softwareLicenses.js";
import { cybersecuritySoftware } from "./categories/cybersecuritySoftware.js";
import { powerSystems } from "./categories/powerSystems.js";
import { coolingHvac } from "./categories/coolingHvac.js";
import { racksCabling } from "./categories/racksCabling.js";
import { physicalSecurity } from "./categories/physicalSecurity.js";
import { datacenterTools } from "./categories/datacenterTools.js";
import { enterpriseElectronicsAV } from "./categories/enterpriseElectronicsAV.js";

export const categoriesData = [
  // Compute & storage
  server,
  storage,
  endUserComputing,
  componentsSpares,

  // Connect & protect
  network,
  securityAppliances,

  // Software
  softwareLicenses,
  cybersecuritySoftware,

  // Datacenter facilities
  powerSystems,
  coolingHvac,
  racksCabling,
  physicalSecurity,
  datacenterTools,

  // Workplace
  enterpriseElectronicsAV,
];
